import React, { useState, useEffect } from "react";
import { Container, Typography, Grid } from "@mui/material";
import HomeCard from "../Component/HomeCard/HomeCard";
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel";
import axios from "axios";

export default function CommunityDevelopment() {
  // State to store fetched Community Development data
  const [communityDevelopment, setCommunityDevelopment] = useState([]);

  // Fetch data from backend when component loads
  useEffect(() => {
    const fetchCommunityDevelopment = async () => {
      try {
        const response = await axios.get(
          "https://urbancasabackendfiles.onrender.com/api/innerProjects?category=CommunityDevelopment"
        );
        setCommunityDevelopment(response.data); // Update state with fetched data
      } catch (error) {
        console.error("Error fetching Community Development projects:", error);
      }
    };

    fetchCommunityDevelopment();
  }, []);

  return (
    <div>
      {/* Video Carousel */}
      <VideoCorousel />

      {/* Community Development Designs */}
      <Container maxWidth="xl" style={{ padding: "40px" }}>
        <Typography variant="h3" align="center" gutterBottom>
          Community Development Designs
        </Typography>

       <Grid container spacing={4} justifyContent="center">

          {communityDevelopment.map((home, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <HomeCard home={home} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
